export const TRANSLATIONS_PT = {
 };